
export type hookType = number;
export let hookType: any = {};
hookType.beforeAddingFile = 0;
hookType.afterAddingFile = 1;
hookType.errorAddingFile = 2;
hookType.prepareUploadFile = 3;
hookType.progressUploadFile = 4;
hookType.successUploadFile = 5;
hookType.completeUploadFile = 6;
hookType.failedUploadFile = 7;
hookType.cancelUploadFile = 8;
hookType.prepareUploadAll = 9;
hookType.progressUploadAll = 10;
hookType.completeUploadAll = 11;
hookType[hookType.beforeAddingFile] = "beforeAddingFile";
hookType[hookType.afterAddingFile] = "afterAddingFile";
hookType[hookType.errorAddingFile] = "errorAddingFile";
hookType[hookType.prepareUploadFile] = "prepareUploadFile";
hookType[hookType.progressUploadFile] = "progressUploadFile";
hookType[hookType.successUploadFile] = "successUploadFile";
hookType[hookType.completeUploadFile] = "completeUploadFile";
hookType[hookType.failedUploadFile] = "failedUploadFile";
hookType[hookType.cancelUploadFile] = "cancelUploadFile";
hookType[hookType.prepareUploadAll] = "prepareUploadAll";
hookType[hookType.progressUploadAll] = "progressUploadAll";
hookType[hookType.completeUploadAll] = "completeUploadAll";

export class UploaderHook {
/**
 * @return {?}
 */
public get type (): hookType | null {
        return this._type;
    }
/**
 * @return {?}
 */
public get priority (): number | null {
        return this._priority;
    }
/**
 * @return {?}
 */
public get callback(): Function | null {
        return this._callback;
    }
private _type: hookType | null = null;
private _callback: Function | null = null;
private _priority: number | null = null;
/**
 * @param {?} _hookType
 * @param {?} _callback
 * @param {?=} _priority
 */
constructor (_hookType: hookType, _callback: Function, _priority = 0) {
        this._type = _hookType;
        this._callback = _callback;
        this._priority = +_priority;
    }
}

function UploaderHook_tsickle_Closure_declarations() {
/** @type {?} */
UploaderHook.prototype._type;
/** @type {?} */
UploaderHook.prototype._callback;
/** @type {?} */
UploaderHook.prototype._priority;
}

